import Swiper from 'swiper';

const dates = document.querySelectorAll('[data-element=date]');
const date = new Date();
const currentDate = date.toLocaleDateString('pt-BR');
let initialSlide = 0;

for (let index = 0; index < dates.length; index += 1) {
  if (dates[index].innerText === currentDate) {
    initialSlide = index;
  }
}

const accordions = document.querySelectorAll('.programming-accordion__label');
Array.from(accordions).forEach((e) => {
  // eslint-disable-next-line no-unused-vars
  e.addEventListener('click', function (event) {
    // eslint-disable-next-line no-undef
    jQuery(`#${this.getAttribute('for')}`).slideToggle();
  });
});

const programming = new Swiper('.swiper-container-date', {
  centeredSlides: true,
  initialSlide,
  slidesPerView: 5,
  slideToClickedSlide: true,
  virtualTranslate: true,
  breakpoints: {
    360: {
      slidesPerView: 1,
      virtualTranslate: false,
      centeredSlides: true,
    },
    768: {
      slidesPerView: 2,
      virtualTranslate: true,
    },
    1200: {
      slidesPerView: 3,
      virtualTranslate: true,
    },
  },
  on: {
    slideChange() {
      const currentSlide = this.slides[this.activeIndex];
      const targetLectureDay = currentSlide.getAttribute('data-target');
      const lectureWrapper = document.getElementsByClassName('lecture-day');

      Array.prototype.forEach.call(lectureWrapper, (e) => {
        e.classList.remove('is-active');
      });

      document.getElementById(targetLectureDay).classList.toggle('is-active');
      // eslint-disable-next-line no-undef
      const programmingSlideChange = new Event('programmingSlideChange');
      document.dispatchEvent(programmingSlideChange);
    },
  },
});

export default programming;
